



export function getSecondLevelDomain(fullHostname: string): string {
    var split = fullHostname.split(".");
    if(split && split.length >= 2) {
        return split[split.length-2] +  "." + split[split.length-1];
    }
    else throw "Could not get domain";
}

export function getThirdDomainName(fullHostname: string): string {
    var split = fullHostname.split(".");
    if(split && split.length >= 3) {
        return split[split.length-3];
    }
    else return null;

}



const ipAddrRegex = /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/i;

const ymDevRegex = new RegExp("(?:(?:api|youmedia).(?:fanpage.)?run|video.(?:(?:cookist|geopop|wamily|lexplain|kodami|ohga).)(?:bar|run))$")
const ymStagingRegex = new RegExp("(?:test.youmedia.(?:fanpage.)?it|videotest.(?:(?:cookist|geopop|wamily|lexplain|kodami|ohga).)(?:com|it))$")

export function isTestHost(fullHostname: string): boolean {
    
    if(!fullHostname || fullHostname.includes("localhost") 
        || ipAddrRegex.test(fullHostname) || ymDevRegex.test(fullHostname) 
            || ymStagingRegex.test(fullHostname)) return true;
    
    const third = getThirdDomainName(fullHostname);
    return third && third.includes("test")
    
}



